var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useAddressesData } from "../SWR/Addresses/useAddressesData";
/**
 * Wrapper hook for useAddressesData that maintains backward compatibility.
 *
 * This hook:
 * - Calls useAddressesData for all address data (from SWR cache)
 * - Wraps return value in { addressState } structure
 * - Injects usesLocation/usesZipCodes from plans data
 *
 * @param orderId - Order ID for context
 * @param programId - Filter pickup locations by program ID
 * @param programSKU - Program SKU (kept for API compatibility)
 *
 * @returns { addressState } matching legacy interface
 */
export const useAddresses = (orderId, programId, programSKU) => {
    var _a, _b, _c;
    // Get all address data from SWR cache
    const data = useAddressesData({ orderId, programId, programSKU });
    const { isLoading, hasError, plansResponse } = data, rest = __rest(data, ["isLoading", "hasError", "plansResponse"]);
    // Look up plan to get usesLocation/usesZipCodes
    const plan = (_a = plansResponse === null || plansResponse === void 0 ? void 0 : plansResponse.data) === null || _a === void 0 ? void 0 : _a.find((p) => p.programId === programId);
    const usesLocation = (_b = plan === null || plan === void 0 ? void 0 : plan.usesLocation) !== null && _b !== void 0 ? _b : false;
    const usesZipCodes = (_c = plan === null || plan === void 0 ? void 0 : plan.usesZipCodes) !== null && _c !== void 0 ? _c : false;
    // Build addressState with missing legacy properties
    // Note: Type cast needed because DeliveryAddressStateType expects DeliveryAddressesAndQuestions[]
    // but useAddressesData correctly returns DeliveryAddressType[] (what API actually returns)
    // The extra properties (questions, deliveryScheduleID) are never accessed by components
    const addressState = Object.assign(Object.assign({}, rest), { 
        // Inject usesLocation/usesZipCodes from plans data
        usesLocation,
        usesZipCodes, 
        // Legacy property not provided by useAddressesData (always null in old implementation)
        subscriptionActiveOrdersData: null });
    return {
        addressState,
    };
};
